<template>
  <div class="modal animated is-active" v-if="service">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Change #{{change_id}}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error">{{error}}</div>
        <div class="content">
          <div class="columns">
            <div class="column is-6">
              <h4 class="title">{{ service.booking_id }}-{{ service.service_id }}</h4>
              <div class="panel panel-info">
                <p class="panel-heading panel-heading-info">Hotel</p>
                <p class="panel-block"><i class="fa fa-bed"></i> {{ service.room.hotel.name }}</p>
                <p class="panel-block"><i class="fa fa-th-list"></i>
                  {{ service.room.description.substring(0,45) }}
                  <template v-if="service.room.description.length > 45">
                    <tooltip style="word-break: break-all;" :label="service.room.description" type="default" placement="right">
                      <a class="is-small">
                        <i class="fa fa-eye"></i>
                      </a>
                    </tooltip>
                  </template>
                </p>
                <p class="panel-block"><i class="fa fa-cutlery"></i> {{ service.room.board_description }} </p>
                <p class="panel-block"><i class="fa fa-cutlery"></i> {{ service.room.provider.name }} # {{ service.room.provider_booking_code }} </p>
                <p class="panel-block"><i class="fa fa-calendar"></i> <b>{{ service.service_date | moment('YYYY-MM-DD') }}</b> to <b>{{ service.service_date | moment('add', service.room.number_nights + ' days', 'YYYY-MM-DD')}}</b></p>
                <p class="panel-block"><i class="fa fa-user"></i> {{ service.paxes.length }}</p>
                <p class="panel-block"><i class="fa fa-group"></i> Adults: <b>{{ service.room.number_adults }}</b> Children: <b>{{ service.room.number_children }}</b></p>
                <p class="panel-block"><i class="fa fa-moon-o"></i> {{ service.room.number_nights }}</p>
                <p class="panel-block"><i class="fa fa-usd"></i> Net: <b>{{ service.price + " " + service.currency }}</b> Provider: <b>{{ service.room.provider_price + " " + service.room.provider_currency }}</b></p>
                <p class="panel-block"><i class="fa fa-globe"></i> {{ service.room.hotel.city.name }}</p>
                <p class="panel-block"><i class="fa fa-map-marker"></i> {{ service.room.hotel.address }}</p>
                <p class="panel-block"><i class="fa fa-phone"></i> {{ service.room.hotel.phone }}</p>
              </div>
              <div class="panel">
                <p class="panel-heading">Cancellation</p>
                <p class="panel-block" v-for="cancellation in service.room.cancellation"><i class="fa fa-ban"></i> <b>From: </b> {{ cancellation.start_date | moment('YYYY-MM-DD hh:mm A') }} <b>To: </b>{{ cancellation.end_date | moment('YYYY-MM-DD hh:mm A') }} <b>Value: <span style="color: red;"> {{ parseFloat(cancellation.price).toFixed(2) }} {{cancellation.currency}}</span></b> - <b>{{ parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'}}</b></p>
              </div>
              <template v-if="service.observation && service.observation !== ''">
                <div class="panel panel-info">
                  <p class="panel-heading panel-heading-info">Observation</p>
                  <p class="panel-block">
                  <pre>{{ service.observation }}</pre>
                  </p>
                </div>
              </template>
            </div>
            <div class="column is-6">
              <template v-if="change">
                <h4 class="title">{{ change.booking_id }}-{{ change.service_id }}</h4>
                <div class="panel panel-info">
                  <p class="panel-heading panel-heading-info">Hotel</p>
                  <p class="panel-block"><i class="fa fa-bed"></i> {{ change.room.hotel.name }} <span v-html="checkDiff(service.room.hotel.name, change.room.hotel.name, true, true)"></span></p>
                  <p class="panel-block"><i class="fa fa-th-list"></i>
                    {{ change.room.description.substring(0,45) }}
                    <template v-if="change.room.description.length > 45">
                      <tooltip style="word-break: break-all;" :label="change.room.description" type="default" placement="right">
                        <a class="is-small">
                          <i class="fa fa-eye"></i>
                        </a>
                      </tooltip>
                    </template>
                    <span v-html="checkDiff(service.room.description, change.room.description, true, true)"></span>
                  </p>
                  <p class="panel-block"><i class="fa fa-cutlery"></i> {{ change.room.board_description }} <span v-html="checkDiff(service.room.board_description, change.room.board_description, true, true)"></span></p>
                  <p class="panel-block"><i class="fa fa-cutlery"></i> {{ change.room.provider.name }} # {{ change.room.provider_booking_code }} </p>
                  <p class="panel-block"><i class="fa fa-calendar"></i> <b>{{ change.service_date | moment('YYYY-MM-DD') }}</b> to <b>{{ change.service_date | moment('add', change.room.number_nights + ' days', 'YYYY-MM-DD')}}</b> <span v-html="checkDiff(parseDate(service.service_date), parseDate(change.service_date))"></span></p>
                  <p class="panel-block"><i class="fa fa-user"></i> {{ change.paxes.length }}</p>
                  <p class="panel-block"><i class="fa fa-group"></i> Adults: <b>{{ change.room.number_adults }}</b> Children: <b>{{ change.room.number_children }}</b></p>
                  <p class="panel-block"><i class="fa fa-moon-o"></i> {{ change.room.number_nights }}</p>
                  <p class="panel-block"><i class="fa fa-usd"></i> Net: <b>{{ change.price + " " + change.currency }}</b> Provider: <b>{{ change.room.provider_price + " " + change.room.provider_currency }}</b> <span v-html="checkDiff(service.room.provider_price, change.room.provider_price)"></span></p>
                  <p class="panel-block"><i class="fa fa-globe"></i> {{ change.room.hotel.city.name }} <span v-html="checkDiff(service.room.hotel.city.name, change.room.hotel.city.name, false, true)"></span></p>
                  <p class="panel-block"><i class="fa fa-map-marker"></i> {{ change.room.hotel.address }} <span v-html="checkDiff(service.room.hotel.address, change.room.hotel.address, true, true)"></span></p>
                  <p class="panel-block"><i class="fa fa-phone"></i> {{ change.room.hotel.phone }}</p>
                </div>
                <div class="panel">
                  <p class="panel-heading">Cancellation</p>
                  <p class="panel-block" v-for="cancellation in change.room.cancellation"><i class="fa fa-ban"></i> <b>From: </b> {{ cancellation.start_date | moment('YYYY-MM-DD hh:mm A') }} <b>To: </b>{{ cancellation.end_date | moment('YYYY-MM-DD hh:mm A') }} <b>Value: <span style="color: red;"> {{ parseFloat(cancellation.price).toFixed(2) }} {{cancellation.currency}}</span></b> - <b>{{ parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'}}</b></p>
                </div>
                <template v-if="change.observation && change.observation !== ''">
                  <div class="panel panel-info">
                    <p class="panel-heading panel-heading-info">Observation</p>
                    <p class="panel-block">
                    <pre>{{ change.observation }}</pre>
                    </p>
                  </div>
                </template>
              </template>
              <template v-else>
                <div>
                  <p class="panel-block" style="text-align: center;"><i style="font-size: 150px;" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary" @click="close(false, '')" :class="{'is-disabled': inProgress}">Close</a>
        <template v-if="change">
          <a class="button" @click="protection()" :class="{'is-success': parseInt(change.protection) == 0, 'is-info': parseInt(change.protection) == 1, 'is-disabled': inProgress || charge == 1 || checkCheckin() || parseInt(change.protection) == 2, 'is-loading': inProgress}">{{ parseInt(change.protection) == 0 ? 'Cancel & Protect' : 'Unprotect' }}</a>
          <a class="button is-warning" @click="cancel()" :class="{'is-disabled': inProgress || checkCheckin() || parseInt(change.protection) == 2, 'is-loading': inProgress}">Cancel</a>
          <a class="button is-success" @click="confirm()" :class="{'is-disabled': inProgress || charge == 1 || checkCheckin(), 'is-loading': inProgress}">Comfirm</a>
        </template>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import Tooltip from 'vue-bulma-tooltip'
  export default {
    props: {
      context: {
        type: Object
      },
      old_service_id: {
        type: Number,
        required: true
      },
      new_service_id: {
        type: Number,
        required: true
      },
      charge: {
        type: Number,
        required: true
      },
      change_id: {
        type: Number,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        service: null,
        change: null,
        inProgress: false,
        error: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      checkCheckin () {
        if (this.$moment(this.$moment(this.change.start_date).format('YYYY-MM-DD')) <= this.$moment()) {
          return false
        } else {
          return true
        }
      },
      protection () {
        this.inProgress = true
        if (window.confirm('Are you sure?')) {
          if (parseInt(this.change.protection) === 0) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/bi/protect_cancel', {'change': this.change_id}).then((response) => {
              this.inProgress = false
              if (response.body.hasOwnProperty('error')) {
                this.error = response.body.description
              } else {
                this.close(false, '')
              }
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/bi/unprotect', {'change': this.change_id}).then((response) => {
              this.inProgress = false
              if (response.body.hasOwnProperty('error')) {
                this.error = response.body.description
              } else {
                this.close(false, '')
              }
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        } else {
          this.inProgress = false
        }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/services/service/' + this.old_service_id).then((response) => {
          this.service = response.body
          document.body.appendChild(this.$el)
          this.loadNewService()
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      loadNewService () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/services/service/' + this.new_service_id).then((response) => {
          this.change = response.body
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      parseChildrens (childrens) {
        if (childrens.hasOwnProperty('int') && Array.isArray(childrens.int)) {
          return childrens.int.length
        } else if (childrens.hasOwnProperty('int') && !Array.isArray(childrens.int)) {
          return 1
        } else {
          return childrens.length
        }
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      cancel () {
        this.inProgress = true
        if (window.confirm('Are you sure you want to cancel?')) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/bi/cancel_change', {'old_service_id': this.old_service_id}).then((response) => {
            this.inProgress = false
            if (response.body.hasOwnProperty('error')) {
              this.error = response.body.description
            } else {
              this.close(false, '')
            }
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        } else {
          this.inProgress = false
        }
      },
      confirm () {
        this.inProgress = true
        this.context.$http.post(this.context.$store.state.config.apiURL + '/bi/confirm_booking', {change: {id: this.change_id}}).then((response) => {
          this.inProgress = false
          if (response.body.hasOwnProperty('error')) {
            this.error = response.body.description
          } else {
            this.close(false, '')
          }
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
      },
      clearCharacters (s) {
        var map = {
          'â': 'a',
          'Â': 'A',
          'à': 'a',
          'À': 'A',
          'á': 'a',
          'Á': 'A',
          'ã': 'a',
          'Ã': 'A',
          'ê': 'e',
          'Ê': 'E',
          'è': 'e',
          'È': 'E',
          'é': 'e',
          'É': 'E',
          'î': 'i',
          'Î': 'I',
          'ì': 'i',
          'Ì': 'I',
          'í': 'i',
          'Í': 'I',
          'õ': 'o',
          'Õ': 'O',
          'ô': 'o',
          'Ô': 'O',
          'ò': 'o',
          'Ò': 'O',
          'ó': 'o',
          'Ó': 'O',
          'ü': 'u',
          'Ü': 'U',
          'û': 'u',
          'Û': 'U',
          'ú': 'u',
          'Ú': 'U',
          'ù': 'u',
          'Ù': 'U',
          'ç': 'c',
          'Ç': 'C',
          '.': '',
          '&': '',
          '-': ''
        }
        return s.replace(/[\W[\] ]/g, function (a) {
          return map[a] || a
        })
      },
      checkDiff (before, after, space = false, clear = false) {
        if (clear && !space) {
          return this.clearCharacters(before).toLowerCase() !== this.clearCharacters(after).toLowerCase() ? '<i class="fa fa-exclamation-triangle" style="color: red;"></i>' : ''
        } else if (space && !clear) {
          return before.replace(/\s/g, '').toLowerCase() !== after.replace(/\s/g, '').toLowerCase() ? '<i class="fa fa-exclamation-triangle" style="color: red;"></i>' : ''
        } else if (space && clear) {
          return this.clearCharacters(before).replace(/\s/g, '').toLowerCase() !== this.clearCharacters(after).replace(/\s/g, '').toLowerCase() ? '<i class="fa fa-exclamation-triangle" style="color: red;"></i>' : ''
        } else {
          return before.toLowerCase() !== after.toLowerCase() ? '<i class="fa fa-exclamation-triangle" style="color: red;"></i>' : ''
        }
      },
      parseDate (content) {
        return this.$moment(content).format('YYYY-MM-DD')
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      Tooltip
    }
  }
</script>
<style lang="scss" scoped>
.is-title {
  text-transform: capitalize;
}

.content p:not(:last-child) {
  margin-bottom: 0;
}

.panel {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
  background-color: rgb(167, 28, 32);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-success {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(35, 209, 96), 0px 0px 0px 1px rgb(35, 209, 96);
  color: #23d160;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-success {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: block;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(35, 209, 96), 0px 0px 0px 0px rgb(35, 209, 96);
  background-color: rgb(35, 209, 96);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-info {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
  color: #3273dc;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-info {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(50, 115, 220), 0px 0px 0px 0px rgb(50, 115, 220);
  background-color: rgb(50, 115, 220);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel-warning {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(255, 221, 87), 0px 0px 0px 1px rgb(255, 221, 87);
  color: #ffdd57;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}

.panel-heading-warning {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: block;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(255, 221, 87), 0px 0px 0px 0px rgb(255, 221, 87);
  background-color: rgb(255, 221, 87);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel .panel-blank {
  border: none;
}

pre {
  background-color: #FFFFFF;
  white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
  white-space: -pre-wrap; /* Opera */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
  word-wrap: break-word; /* IE 5.5+ */
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #4a4a4a;
  font-size: 1rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// ChangeCheck.vue?28d27097